import React from "react";
import ModalDisplay from "./ModalDisplay";
import Div from "../../components/common/Div";
import Text from "../../components/common/Text";
import ModalButton from "../../components/common/ModalButton";
import { tenzero } from "../../constants/Constants";
import { Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
export default function SubmitTestBox(props) {
  let displayValue = "none";
  if (props.display) displayValue = "block";

  return (
    <ModalDisplay display={displayValue}>
      <div style={iconContainerStyle}>
        <CheckCircleIcon style={successIconStyle} />
      </div>
      <Div margin={tenzero}>
        <Typography
          fontWeight={"bold"}
          color={"rgb(33, 42, 65)"}
          style={{ fontSize: "1.25rem", textAlign: "center" }}
        >
          Confirm
        </Typography>
      </Div>
      <Div margin={tenzero}>
        <Text color={"rgb(33, 42, 65)"} fontSize={"0.9rem"}>
          Are you sure you want to close results?
        </Text>
      </Div>
      <Div style={{ display: "flex", gap: "10px" }} margin={tenzero}>
        <ModalButton onClick={props.handler1}>Cancel</ModalButton>
        <ModalButton onClick={props.handler2}>Confirm</ModalButton>
      </Div>
    </ModalDisplay>
  );
}

const iconContainerStyle = {
  display: "flex",
  width: "fit-content",
  justifyContent: "center",
  marginBottom: "15px",
  backgroundColor: "rgb(33, 42, 65, 0.3)",
  borderRadius: "20%",
  padding: "10px",
  margin: "0 auto",
};

const successIconStyle = {
  color: "rgb(33, 42, 65)",
  fontSize: "2rem",
};
